const DISPATCH_TAB_TICKET_ACTIVITIES_EVENT = 'DISPATCH_TAB_TICKET_ACTIVITIES_EVENT';
const ACTIVITY_API_CALL_BOUNCE = 5000;

const TicketActivityTypeMap = {
    editing: 'editing',
    visiting: 'visiting',
    idle: 'idle'
} as const;

type TicketActivityType = keyof typeof TicketActivityTypeMap;

interface TicketActivity {
    [TicketActivityTypeMap.editing]: string[];
    [TicketActivityTypeMap.visiting]: string[];
    [TicketActivityTypeMap.idle]: string[];
    lastChange: number;
    hasActivity: boolean;
}

interface BulkTicketActivities {
    [key: string]: TicketActivity;
}

function fireDispatchTabTicketActivitiesEvent(activities: BulkTicketActivities) {
    window.dispatchEvent(
        new CustomEvent<DispatchTabTicketActivitiesEvent>(DISPATCH_TAB_TICKET_ACTIVITIES_EVENT, {
            detail: { activities },
            bubbles: true
        })
    );
}

export {
    ACTIVITY_API_CALL_BOUNCE,
    DISPATCH_TAB_TICKET_ACTIVITIES_EVENT,
    fireDispatchTabTicketActivitiesEvent,
    TicketActivityTypeMap
};
export { type BulkTicketActivities, type TicketActivity, type TicketActivityType };
